<template>
	<v-card color="teal">
		<v-card-title class="body-1 pl-4, white--text">{{ dia }}</v-card-title>
			<v-btn @click="muestraFecha" rounded x-small>{{ datos.fecha }}</v-btn>
		<v-card-text class="body-1 pl-4, white--text">{{ datos.cantidad }}</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'TarjetaCitas',
	props: {
		dia: {
			type: String,
			required: true,
		},
		datos: {
			type: Object,
			required: true
		},
	},
	data() {
		return {

		}
	},
	methods:  {
		muestraFecha() {
			//alert("La fecha es: " + this.datos.fecha)
			let infoParaConsulta = {
				idTerapeuta: this.$session.get("esAdmin") ? 0 : this.$session.get("idUsuario"),
				fechaActual : this.datos.fecha
			}
			this.$emit('fechaDeCita', infoParaConsulta) 
		},
	},
}
</script>

